// noinspection JSUnusedGlobalSymbols

import { teamSlice } from './team.slice.ts';

export const { setSelectedTeamState } = teamSlice.actions;
